module.exports = __webpack_public_path__ + "img/3d-image.7c073368.png";